module.exports = __webpack_public_path__ + "img/faq_fr.342858d4.png";